<template>
  <div class="stockwrap">
    <!--startprint-->
    <div v-bind="stockData" class="stockMain" id="printBox">
      <div class="stockMain title" id="printTitle">采购出库单</div>
      <div class="stockMain content">
        <ul>
          <li>
            <div>采购入库单编号: {{stockData.purchaseNumber}}</div>
          </li>
          <li>
            <div>采购商户名称: {{stockData.shopName}}</div>
          </li>
          <li>
            <div>法人姓名: {{stockData.name}}</div>
          </li>
          <li>
            <div>店铺地址: {{stockData.address}}</div>
          </li>
          <li>
            <div>采购时间: {{handleFormatterDateToUTC(stockData.purchaseTime)}}</div>
          </li>
          <li>
            <avue-crud
              :option="tableOption"
              :data="tableData"
              :table-loading="tableLoading"
              ref="crud"
            ></avue-crud>
          </li>
          <li>
            <div>商品数量共计: {{stockData.totalNumber}}</div>
          </li>
          <li>
            <div>采购金额: {{stockData.totalMoney}}元</div>
          </li>
          <li>
            <div>结算方式: {{stockData.clearingType == "INSTALLMENT"?"月结":"现款现货"}}</div>
          </li>
          <li>
            <div>支付状态: {{stockData.payStatus == 'FINISH' ? '已支付' : '待支付'}}</div>
          </li>
          <li v-if="stockData.status">
            <div>订单状态: {{stockData.status == 'WAIT_PAY_MONEY' ? '待付款' : (stockData.status == 'WAIT_STOCK' ? '待出库' : (stockData.status == 'WAIT_RECEIV' ? '待收货': (stockData.status == 'RETURNED' ? '已退回': (stockData.status == 'DONE' ? '已完成': (stockData.status == 'LOSE' ? '已失效': (stockData.status == 'CANCEL' ? '已取消': ('StatusError:'+stockData.status)))))))}}</div>
          </li>
          <li v-if="stockData.status == 'RETURNED'">
            <div>退回时间: {{stockData.returnTime?handleFormatterDateToUTC(stockData.returnTime):stockData.returnTime}}</div>
          </li>
          <li v-if="stockData.status == 'RETURNED'">
            <div>退回原因: {{stockData.returnReason}}</div>
          </li>
          <li
            v-if="stockData.status == 'WAIT_RECEIV' || stockData.status == 'WAIT_PAY_MONEY' || stockData.status == 'DONE'"
          >
            <div>出库时间: {{stockData.removalTime?handleFormatterDateToUTC(stockData.removalTime):stockData.removalTime}}</div>
          </li>
          <li v-if="stockData.status == 'WAIT_PAY_MONEY' || stockData.status == 'DONE'">
            <div>收货时间: {{stockData.receiveTime?handleFormatterDateToUTC(stockData.receiveTime):stockData.receiveTime}}</div>
          </li>
          <li v-if="stockData.status == 'DONE'">
            <div>支付时间: {{stockData.payTime?handleFormatterDateToUTC(stockData.payTime):stockData.payTime}}</div>
          </li>
          <li v-if="stockData.status == 'CANCEL'">
            <div>取消时间: {{stockData.cancelTime?handleFormatterDateToUTC(stockData.cancelTime):stockData.cancelTime}}</div>
          </li>
          <li v-if="stockData.status == 'LOSE'">
            <div>失效时间: {{stockData.loseTime?handleFormatterDateToUTC(stockData.loseTime):stockData.loseTime}}</div>
          </li>
        </ul>
      </div>
      <div class="stockMain btn" id="noprint">
        <el-button
          @click="doPdf"
          v-if="stockData.status !='CANCEL' && stockData.status !='LOSE'"
        >下载PDF</el-button>
        <el-button
          @click="doPrint"
          v-if="stockData.status !='CANCEL' && stockData.status !='LOSE'"
        >打印</el-button>
        <el-button v-if="stockData.status == 'WAIT_STOCK'" @click="reasonDialog = true">退回</el-button>
        <el-button v-if="stockData.status == 'WAIT_STOCK'" @click="handleOut">出库</el-button>
        <el-button
          v-if="stockData.status == 'WAIT_RECEIV' || stockData.status == 'WAIT_PAY_MONEY'"
          @click="toArDetail"
        >查看应收款</el-button>
      </div>
    </div>
    <!--endprint-->
    <el-dialog :visible.sync="reasonDialog" title="退回理由" center width="300px">
      <div style="display: flex;">
        <el-input type="textarea" :rows="4" placeholder="请输入退回理由" v-model="returnReason"></el-input>
      </div>
      <div class="typeButton">
        <el-button
          round
          size="mini"
          @click="reasonDialog = false"
        >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
        <el-button
          round
          type="danger"
          size="mini"
          @click="typeEditOk"
        >&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { stockFormOption } from "@/const/salesCloud/stockFormOption";
import {
  findStockRemovalDetail,
  stockRemovalReturn,
  stockRemoval,
  downloadPDF
} from "@/api/salesCloud/stockForm";
import { formatterDateToUTC } from "@/util/util";

export default {
  name: "elstockForm",
  data() {
    return {
      tableOption: stockFormOption, //表格设置属性
      tableData: [], //表格的数据
      stockData: {},
      tableLoading: false,
      reasonDialog: false,
      returnReason: "",
      // detailId:this.$route.query.id
      detailId: this.$route.params.id
    };
  },
  watch: {},
  created() {
    // console.log(this)
    this.handleList();
  },
  mounted() {},
  methods: {
    handleOut() {
      console.log(this.detailId);
      stockRemoval(this.detailId).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "出库成功",
            type: "success"
          });
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
      // this.evaluateDialog =true
      console.log(this);
    },
    toArDetail() {
      let params = {
        arNumber: this.stockData.arNumber,
        id: this.stockData.shopId
      };
      console.log(params);
      this.$router.push({ name: "应收款详情", params });
    },
    typeEditOk() {
      console.log(this.stockData);
      let params = {
        returnReason: this.returnReason
      };
      console.log(params);
      stockRemovalReturn(this.detailId, params).then(res => {
        console.log(res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "退回成功",
            type: "success"
          });
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          this.handleList();
        }
      });
    },
    handleFormatterDateToUTC(data) {
      return formatterDateToUTC(data);
    },
    handleList() {
      // 从sessionStorage获取数据
      // let id = sessionStorage.getItem("key");
      // if(id){
      // this.detailId=id
      // 从sessionStorage删除保存的数据
      // sessionStorage.removeItem("key");
      // }else{
      this.detailId = this.$route.params.id;
      // }
      // let id = this.goodDetailId
      // let mockid = "402883886e692787016e6931d3380000";
      this.tableLoading = true;
      // let parmas = {};

      findStockRemovalDetail(this.detailId).then(res => {
        let data = JSON.parse(res.data);
        console.log(this);
        console.log("findStockRemovalDetail", data);
        this.stockData = data;
        this.tableData = data.purchaseGoodsResponseList;
        // this.page = {
        //   total: data.total,
        //   currentPage: this.page.currentPage,
        //   pageSize: this.page.pageSize
        // };
        this.tableLoading = false;
      });
    },
    doPdf() {
      downloadPDF(this.detailId).then(res => {
        console.log(res);
      });
    },
    doPrint() {
      var printBox = document.getElementById("printBox");
      //拿到打印的区域的html内容
      var newContent = printBox.innerHTML;
      //将旧的页面储存起来，当打印完成后返给给页面。
      var oldContent = document.body.innerHTML;
      //赋值给body
      document.body.innerHTML = newContent;
      //执行window.print打印功能
      window.print();
      // 重新加载页面，以刷新数据。以防打印完之后，页面不能操作的问题
      document.body.innerHTML = oldContent;
      window.location.reload(false);
      return false;
    }
  }
};
</script>

<style lang="scss">
@media print {
  #printTitle {
    position: relative;
    left: 50%;
    border: none;
    font-size: 18px;
    margin-left: -37px;
  }

  #noprint {
    display: none;
  }
}
.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.stockwrap {
  background: #fff;
  margin: 1px 10px;
  padding-bottom: 100px !important;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stockwrap {
  background: #fff;
  margin: 1px 10px;
  padding-bottom: 100px !important;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stockMain {
  // border: 1px solid #606266;
  display: flex;
  width: 100%;
  flex-flow: column wrap;
  justify-content: center;
  align-items: flex-start;
  margin: 1px 10px;
  font-size: 14px;
  color: #606266;
  .content {
    border: none;
    ul {
      .titleLi {
        display: flex;
        justify-content: flex-start;
      }
      .titleLi .d {
        width: 300px;
      }
    }
  }
  .title {
    position: relative;
    left: 50%;
    border: none;
    font-size: 18px;
    margin-left: -37px;
  }
  .btn {
    position: absolute;
    bottom: 20px;
    left: 0;
    border: none;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    button {
      margin: 0 20px;
    }
  }
}
.avue-crud {
}
</style>